import React from 'react';
import ListContainer from '../platformui/ListContainer';

const ListContainerBlock = (props) => <ListContainer {...props} />;

export default ListContainerBlock;
